import { SubscriptionTier } from '@/../generated-client/models';

export interface TierListsShape {
  connect_user_auth_ids?: string[];
  ops_user_auth_ids?: string[];
  respond_user_auth_ids?: string[];
}

// Assigned tier = the pool the user's auth_id sits in, highest wins across groups.
// Distinct from effective_tier (which trial can elevate) — this is the raw seat assignment.
export function getUserAssignedTier(
  groups: TierListsShape[] | null | undefined,
  authId: string,
): SubscriptionTier {
  if (!groups?.length || !authId) return SubscriptionTier.Connect;
  let best = SubscriptionTier.Connect;
  for (const g of groups) {
    if (g.respond_user_auth_ids?.includes(authId)) return SubscriptionTier.Respond;
    if (g.ops_user_auth_ids?.includes(authId)) best = SubscriptionTier.Ops;
  }
  return best;
}

// Effective tier mirrors the API's SubscriptionTierService.getEffectiveTier: an active org
// trial elevates every user to Respond (API-3 / spec nm-3); otherwise it is the assigned seat tier.
export function getUserEffectiveTier(
  groups: TierListsShape[] | null | undefined,
  authId: string,
  isOrgOnTrial: boolean,
): SubscriptionTier {
  if (isOrgOnTrial) return SubscriptionTier.Respond;
  return getUserAssignedTier(groups, authId);
}
